import makeStyles from '@mui/styles/makeStyles';
import classnames from 'classnames/bind';
import CardHeader from '@mui/material/CardHeader';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import styles from './index.scss';

const useStyles = makeStyles(() => ({
  titleStyle: (props) => ({
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '18px',
    ...props.titleStyle,
  }),
}));

const cx = classnames.bind(styles);
const CardTitle = ({
  className,
  noTopPadding,
  noVerticalPadding,
  titleStyle,
  ...props
}) => {
  const classes = useStyles({ titleStyle });
  return (
    <CardHeader
      {...props}
      className={useMemo(
        () => cx({
          cardTitle: true,
          noTopPadding,
          noVerticalPadding,
          className,
        }),
        [
          className,
          noTopPadding,
          noVerticalPadding,
        ],
      )}
      classes={{ title: classes.titleStyle }}
    />
  );
};

CardTitle.propTypes = {
  className: PropTypes.string,
  noTopPadding: PropTypes.bool,
  noVerticalPadding: PropTypes.bool,
  titleStyle: PropTypes.object,
};

export default CardTitle;
